var exports = {
  "kL": "GuildBoostTab.module__container___NlZRRX",
  "dc": "GuildBoostTab.module__spinnerContainer___NlZRRX",
  "uW": "GuildBoostTab.module__section___NlZRRX",
  "R_": "GuildBoostTab.module__heading___NlZRRX",
  "Nr": "GuildBoostTab.module__card___NlZRRX",
  "jf": "GuildBoostTab.module__statusRow___NlZRRX",
  "Rc": "GuildBoostTab.module__level___NlZRRX",
  "SU": "GuildBoostTab.module__muted___NlZRRX",
  "qB": "GuildBoostTab.module__progress___NlZRRX",
  "o1": "GuildBoostTab.module__actions___NlZRRX",
  "Gu": "GuildBoostTab.module__boosters___NlZRRX",
  "rq": "GuildBoostTab.module__booster___NlZRRX",
  "my": "GuildBoostTab.module__avatar___NlZRRX",
  "UU": "GuildBoostTab.module__name___NlZRRX",
};

module.exports = exports;
